import React, { useEffect } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { useColors } from '../../hooks/lesson-player.context';
import { useKeyPress } from '../../hooks/use-key-press';
import ActivityFooter from '../activity-footer/activity-footer';
import { Button } from '../button/button';

interface CheckButtonProps {
  onPress: () => void;
  name?: string;
  isVisible?: boolean;
  optionKey?: string;
  hasSafeArea?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
}

export function CheckButton({
  name = 'Check',
  onPress,
  isVisible = true,
  optionKey = 'Enter',
  hasSafeArea = true,
  containerStyle,
}: CheckButtonProps) {
  const colors = useColors();
  const keyPress = useKeyPress(optionKey);

  useEffect(() => {
    if (isVisible && keyPress) {
      onPress();
    }
  }, [isVisible, keyPress, onPress]);

  if (!isVisible) {
    return null;
  }

  return (
    <ActivityFooter style={containerStyle} safeArea={hasSafeArea}>
      <ActivityFooter.ButtonContainer>
        <Button onPress={onPress} backgroundColor={colors.primary}>
          {name}
        </Button>
      </ActivityFooter.ButtonContainer>
    </ActivityFooter>
  );
}
